var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSections = function SvgSections(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M27.108 30.667a6.66 6.66 0 0 0-5.775-3.334H10.667a6.66 6.66 0 0 0-5.775 3.334M27.108 1.333a6.66 6.66 0 0 1-5.775 3.334H10.667a6.66 6.66 0 0 1-5.775-3.334M28 16a6.667 6.667 0 0 1-6.667 6.667H10.667a6.667 6.667 0 0 1 0-13.334h10.666A6.667 6.667 0 0 1 28 16Z"
  })));
};
export default SvgSections;